import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_CONFIG } from '../config/site';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>{SITE_CONFIG.name}</h3>
          <p>Delicious sweets and catering services for all your special occasions.</p>
        </div>
        
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/shop">Shop</Link></li>
            <li><Link to="/custom-order">Custom Order</Link></li>
            <li><Link to="/orders">Orders</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Legal</h4>
          <ul>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Want a Similar App/Website?</h4>
          <p style={{ fontSize: '14px', marginBottom: '10px' }}>
            Contact us to build your custom solution
          </p>
          <a 
            href="mailto:helpyamii@gmail.com?subject=Inquiry about App/Website Development" 
            className="footer-email-link"
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px',
              color: '#FF6B6B',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '600'
            }}
          >
            <span style={{ fontSize: '18px' }}>📧</span>
            helpyamii@gmail.com
          </a>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} {SITE_CONFIG.name}. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
